@if (item.url) {
  <a class="nav-link" [routerLink]="[item.url]" routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: item.exactMatch || false}" matRipple>
    @if (item.icon) {
      <mat-icon class="nav-link-icon">{{item.icon}}</mat-icon>
    }
    <span class="nav-link-title">{{item.title}}</span>
    @if (item.badge) {
      <span class="nav-link-badge"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
      </span>
    }
  </a>
}

@if (item.function) {
  <span class="nav-link" (click)="item.function()" matRipple>
    @if (item.icon) {
      <mat-icon class="nav-link-icon">{{item.icon}}</mat-icon>
    }
    <span class="nav-link-title">{{item.title}}</span>
    @if (item.badge) {
      <span class="nav-link-badge"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
      </span>
    }
  </span>
}